import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { getToken } from "../../utilities/authHelper";
import SuccessModal from "./SuccessModal";
import { fetchProducts } from "../../utilities/AdminUtilities";

function PackageProduct({ selectedPackage, show, handleClose }) {
  const [products, setProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [detailsObject, setDetailsObject] = useState("{}");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  useEffect(() => {
    fetchProducts()
      .then((data) => setProducts(data))
      .catch((error) => console.error("Error fetching products:", error));
  }, []);

  const handleLink = async () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    try {
      const response = await fetch(`${apiUrl}/admin/link_product_package`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          product_id: selectedProductId,
          package_id: selectedPackage.id,
          details_object: JSON.parse(detailsObject),
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to link product with package");
      }

      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error linking product with package:", error);
      setShowErrorModal(true);
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Link Product to Package</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="packageId">
              <Form.Label>Package ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter package ID"
                value={selectedPackage.id}
                disabled={true}
              />
            </Form.Group>
            {/* Product Selection */}
            <Form.Group className="mb-3" controlId="productSelect">
              <Form.Label>Select Product</Form.Label>
              <Form.Select
                value={selectedProductId}
                onChange={(e) => setSelectedProductId(e.target.value)}
              >
                <option value="">Select a Product</option>
                {products.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.product_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* Package ID Input */}

            {/* Details Object */}
            <Form.Group className="mb-3" controlId="detailsObject">
              <Form.Label>Details Object (JSON format)</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter details in JSON format"
                value={detailsObject}
                onChange={(e) => setDetailsObject(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleLink}>
            Link Product to Package
          </Button>
        </Modal.Footer>
      </Modal>

      <SuccessModal
        message={"Product successfully linked to package."}
        showSuccessModal={showSuccessModal}
        setShowSuccessModal={setShowSuccessModal}
      />
      {/* Error Modal */}
      <Modal
        show={showErrorModal}
        onHide={() => setShowErrorModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          An error occurred while linking the product to the package.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PackageProduct;
